/**
 * Wraps cookie banner and preferences modal.
 * Renders banner when consent not given, and modal when opened from footer/settings.
 */
import React from 'react'
import { useConsent } from '../../contexts/ConsentContext'
import CookieBanner from './CookieBanner'
import CookiePreferencesModal from './CookiePreferencesModal'

const CookieConsent = () => {
  const { preferencesModalOpen, closePreferences } = useConsent()

  return (
    <>
      <CookieBanner />
      <CookiePreferencesModal
        open={preferencesModalOpen}
        onClose={closePreferences}
      />
    </>
  )
}

export default CookieConsent
